import axios from 'axios';
import { configRefs } from '@utils/config';
import { CollegeLevels, HFLevels, HighschoolLevels, SchoolLevels, PreschoolLevels, formatGradeLevel } from './model.js';

async function getPortalList() {
  const response = await axios.get(`${await configRefs.apis.papi.get()}/products`);
  const portals = response.data.filter(it => it.type === "Fagportal").map(it => ({
    url: it.url,
    thumbnail: it.cover,
    title: it.shortTitle || it.title,
    licenseKey: it.licenseKey,
    ...formatRawLevels(it.grades)
  }));
  return portals;
}
function formatRawLevels(rawLevels) {
  const sortedLevels = convertRawLevelsToEnum(rawLevels).sort((a, b) => a - b);
  return {
    formattedGradeLevel: createLabelFromLevels(sortedLevels),
    levels: sortedLevels
  };
}
function createLabelFromLevels(levels) {
  if (levels.length === 0) {
    return "Ukendt";
  }
  const minLabel = formatGradeLevel(levels[0]);
  const maxLabel = formatGradeLevel(levels[levels.length - 1]);
  const stringifiedMinLabel = `${minLabel.prefix ? minLabel.prefix + (minLabel.separator ?? " ") : ""}${minLabel.label}`;
  const stringifiedMaxLabel = `${maxLabel.prefix ? maxLabel.prefix + (maxLabel.separator ?? " ") : ""}${maxLabel.label}`;
  if (levels.length === 1) {
    return stringifiedMinLabel;
  }
  if (isOnly(SchoolLevels, levels) || isOnly(HighschoolLevels, levels) || isOnly(HFLevels, levels)) {
    return `${minLabel.prefix}-${maxLabel.prefix} ${maxLabel.label}`;
  }
  return `${stringifiedMinLabel} - ${stringifiedMaxLabel}`;
}

/**
 * Simple helper that identifies if all levels for a given portal all resides
 * within a single level-grouping
 */
function isOnly(level, levels) {
  return levels.every(it => Object.keys(level).includes(String(it)));
}
function convertRawLevelsToEnum(rawLevels) {
  return rawLevels.map(it => {
    switch (it) {
      case "Dagtilbud":
        return PreschoolLevels.DAYCARE;
      case "0. klasse":
        return SchoolLevels.KINDERGARTEN;
      case "1. klasse":
        return SchoolLevels.FIRST;
      case "2. klasse":
        return SchoolLevels.SECOND;
      case "3. klasse":
        return SchoolLevels.THIRD;
      case "4. klasse":
        return SchoolLevels.FOURTH;
      case "5. klasse":
        return SchoolLevels.FIFTH;
      case "6. klasse":
        return SchoolLevels.SIXTH;
      case "7. klasse":
        return SchoolLevels.SEVENTH;
      case "8. klasse":
        return SchoolLevels.EIGHT;
      case "9. klasse":
        return SchoolLevels.NINTH;
      case "10. klasse":
        return SchoolLevels.TENTH;
      case "A-niveau":
        return HighschoolLevels.A;
      case "B-niveau":
        return HighschoolLevels.B;
      case "C-niveau":
        return HighschoolLevels.C;
      case "1 HF":
        return HFLevels.HF1;
      case "2 HF":
        return HFLevels.HF2;
      case "Grundforløb 1":
        return CollegeLevels.BASIC1;
      case "Grundforløb 2":
        return CollegeLevels.BASIC2;
      case "Hovedforløb":
        return CollegeLevels.MAIN;
      case "voksenuddannelse":
        return CollegeLevels.ADULT;
    }
  });
}

export { getPortalList };
//# sourceMappingURL=api.get-list.js.map
